import React from "react"

import ManageYearFormComponent from './manage-year-form-component'
import PPIService from '../../../service/sfp/ppi-service'

class ManageYearContainer extends React.Component {

	state = {
		submitting: false
	}

	render() {
		return (
			<ManageYearFormComponent
				ppi={this.props.ppi}
				action={this.props.action}
				submitting = {this.state.submitting}
				onSubmit      			= {this._handleSubmit}
			/>
		)
	}

	_handleSubmit = (/** @type {React.SyntheticEvent<Element>} */ event) => {
		event.preventDefault();
		event.persist()
		this.setState({ submitting: true }, () => {
			switch(this.props.action) {
				case "add":
					PPIService.addYear(this.props.ppi.id)
						.then(this._resolveAddYear.bind(this, event), this._rejectAddYear)
					break
				case "delete":
					PPIService.deleteLastYear(this.props.ppi.id)
						.then(this._resolveDeleteLastYear.bind(this, event), this._rejectDeleteLastYear)
					break
			}
		})
	}

	_rejectAddYear = (error) => {
		this.props.actions.throwError(error)
		this.setState({error, submitting: false})
	}

	_resolveAddYear = (
	/** @type {React.SyntheticEvent<Element>} */ event,
	/** @type {Object} */               response) => {
		event.target.reset()
		this.setState({ submitting: false }, () => {
			this.props.onYearAdded(response)
		})
	}

	_rejectDeleteLastYear = (error) => {
		this.props.actions.throwError(error)
		this.setState({error, submitting: false})
	}

	_resolveDeleteLastYear = (
	/** @type {React.SyntheticEvent<Element>} */ event,
	/** @type {Object} */               response) => {
		event.target.reset()
		this.setState({ submitting: false }, () => {
			this.props.onLastYearDeleted(response)
		})
	}

}

export default ManageYearContainer



// WEBPACK FOOTER //
// ./src/component/ppi/ppi-detail/manage-year-form-container.js